import type { FunctionComponent, ReactElement } from 'react';
import { useEffect } from 'react';

import { useCoreDispatch } from '../../../../store/CoreStore';
import { useChatSlice } from '../../../../store/slices/chat/selectors';
import { chatActions } from '../../../../store/slices/chat/slice';
import { useConfigSlice } from '../../../../store/slices/config/selectors';
import { Chat } from '../../../chat/chat/Chat';
import { ChatFooterConnected } from '../../../chat/chat/footer/ChatFooterConnected';
import { MessagesWrapperConnected } from '../../../chat/chat/messages/messagesWrapper/MessagesWrapperConnected';
import { PrivateChatOptionsConnected } from '../../../chat/chat/messages/privateChatOptions/PrivateChatOptionsConnected';

export const NavPageChatConnected: FunctionComponent = (): ReactElement => {
  const dispatch = useCoreDispatch();
  const gameChatMessages = useChatSlice.getGameChatMessages();
  const isPrivateTable = useConfigSlice.isPrivateTable();

  useEffect(() => {
    dispatch(chatActions.setUnreadPrivateMessageCounter(0));
  }, [dispatch]);

  return (
    <Chat
      chatFooter={<ChatFooterConnected isGameChat />}
      messagesWrapper={<MessagesWrapperConnected messages={gameChatMessages} />}
      privateOptions={isPrivateTable ? <PrivateChatOptionsConnected /> : null}
    />
  );
};
